import React, { useState } from 'react';
import { TabContent } from '../../../common/sharedComponents/TabContent';
import { IMyAuditSections } from '../../../@types/myAudit';
import { Grid } from '../../../common/sharedComponents/Grid';
import { QuestionCard } from '../../../myAudit/components/QuestionCard';
import { MyAuditViewComments } from './MyAuditViewComments';
import {
  TabContentGridContainer,
  TabsContentCommentsContainer,
} from '../../../common/sharedComponents/TabContent/TabContent.styled';
import { convertTaggedUsersInitialState } from '../../../myAudit/utils';

export interface IMyAuditViewTabContent {
  section: IMyAuditSections;
}

export function MyAuditViewTabContent ({ section }: IMyAuditViewTabContent) {
  const [isGripOpen, setIsGridOpen] = useState<boolean>(false);

  return (
    <TabContent title={section.name}>
      <TabContentGridContainer>
        <Grid
          media={section && section.attachments}
          isView={true}
          isGridOpen={isGripOpen}
          handleOpenGrid={() => setIsGridOpen(!isGripOpen)}
        />
      </TabContentGridContainer>
      {section &&
        section.standards.map((standard) => {
          return (
            <QuestionCard
              key={standard.id}
              question={standard}
              showDropdownIcon={true}
              isView={true}
            />
          );
        })}
      <TabsContentCommentsContainer>
        <MyAuditViewComments
          tagged={convertTaggedUsersInitialState(section.tagged)}
          comments={section.comments}
          roomNumber={section.roomNumber}
          outletName={section.outletName}
          mealPeriod={section.mealPeriod}
        />
      </TabsContentCommentsContainer>
    </TabContent>
  );
}
